import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {SegmentInformationDto} from "../dto/segment.information.dto";
import {PropertyAddressResponseDto} from "../dto/property.address.response.dto";

@Injectable({
    providedIn: 'root'
})
export class PropertySubject {

    private propertySubject: BehaviorSubject<PropertyAddressResponseDto | null> = new BehaviorSubject<PropertyAddressResponseDto | null>(null);
    private propertyNameSubject = new BehaviorSubject<string | null>(null);
    propertyName$ = this.propertyNameSubject.asObservable();

    /**
     * Actualiza el segmento seleccionado en el BehaviorSubject.
     * @param segment El segmento seleccionado por el usuario.
     */
    public setPropertyResponse(property: PropertyAddressResponseDto): void {
        if (this.propertySubject.value !== property) {
            this.propertySubject.next(property);
            console.log('Segmento seleccionado:', property);
        }
    }

    /**
     * Obtiene el segmento seleccionado actualmente.
     * @returns El segmento seleccionado actual.
     */
    public getPropertyResponse$(): PropertyAddressResponseDto | null {
        return this.propertySubject.value;
    }
    // Método para actualizar el nombre de la propiedad
    setPropertyName(name: string | null) {
        this.propertyNameSubject.next(name);
    }


    // Método para obtener el valor actual sin suscribirse
    getPropertyName(): string | null {
        return this.propertyNameSubject.getValue();
    }

    /** Limpia el estado de la propiedad en construcción (publicación nueva). */
    clear(): void {
        this.propertySubject.next(null);
        this.propertyNameSubject.next(null);
    }
}
